export const AcnColorTheme = {
  // primary: "#0457AE",
  primary: "#FFD100", // new chaiyo
  secondaryRed: "#F5333F", // new chaiyo
  secondary: "#000000",
  accept: "#34A853",
  danger: "#FF0008",
  warning: "#FBBC05",
  success: "#34A853",
  background: "#FFFFFF",
  white: "#FFFFFF",
  divider: "#A0A0A0",

  orange: "#F9752B",
  lightOrange: "#FFC700",

  black: "#101B2A",
  darkBlue: "#000F9F",
  primaryBlack: "#000000",

  darkGrey: "#757E8A",
  lightGrey: "#E3E5E8",
  remarkGrey: "#939AA4",
  grey100: "#F9F9FA",
  grey50: "#FEFEFE",
  grey: "#808080",

  ghostWhite: "#F9FAFA", // TBC color name
  primaryPurple: "#B8BEFF",
  lightPurple: "#F5F6FF",

  lightBlue: "#6674FF",
};
